module.exports = __webpack_public_path__ + "static/media/Qase_online_video_consult.6610dc9f.png";